module.exports = __webpack_public_path__ + "img/p_syjc.cc442e1e.png";